module.exports = __webpack_public_path__ + "static/media/three-dots.4a599d47.svg";